import { checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

const checkoutLineItemsRemoveMutation = (
	`mutation ($checkoutId: ID!, $lineItemIds: [ID!]!) {
		checkoutLineItemsRemove(checkoutId: $checkoutId, lineItemIds: $lineItemIds) {
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default checkoutLineItemsRemoveMutation;
